export const getFullName = (firstName: string, lastName: string): string => {
    return [lastName, firstName].filter(Boolean).join(" ");
};
